import { Dictionary } from '@direct-frontend/stdlib';

import { BaseUnionConstituent, BaseUnionField } from '../createUnionField';

// Получает декларацию текущего объектного поля, подходящего под значение поля-юниона
export function getActualUnionFieldConstituent(
    field: BaseUnionField,
    fieldValue: Dictionary<unknown>
): BaseUnionConstituent<string> {
    const keyValue = fieldValue?.[field.key];

    return field.constituents.find(
        (constituent: BaseUnionConstituent<string>) => constituent.fields[field.key]?.defaultValue === keyValue
    );
}
